<template>

  <v-menu v-model="menu" offset-y class="pa-0">

    <template v-slot:activator="{ on }">
      <v-btn fab depressed style="height: 48px; width: 48px" color="primary" v-on="on">
        <template v-if="profile && profile.avatar">
          <v-avatar>
            <v-img :src="profile.avatar"/>
          </v-avatar>
        </template>
        <template v-else>
          <v-progress-circular indeterminate/>
        </template>
      </v-btn>
    </template>

    <v-card outlined width="300">


      <v-card-text class="pa-2">
        <v-list-item class="mx-n3 mt-n2 mb-n2">
          <v-list-item-avatar>
            <v-img :src="profile.avatar"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="profile.full_name"/>
            <v-list-item-subtitle v-text="profile.email"/>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>

      <v-divider class="mx-3"/>

      <v-card-text class="pa-2">
        <v-row no-gutters>
          <v-col cols="12" class="pa-1">
            <v-btn color="primary" block depressed @click="doLogout">
              <v-icon left>mdi-exit-to-app</v-icon>
              Logout
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>


    </v-card>
  </v-menu>


</template>

<script>

  import {mapActions} from 'vuex'
  import profile_repository from '@/repositories/profile-repository';

  export default {

    data: () => ({
      menu: false,
      profile: {
        avatar: null
      }
    }),

    async created() {
      this.profile = await profile_repository.getMyProfile();
    },

    methods: {

      ...mapActions('account', ['logout']),

      doLogout() {
        this.logout();
      }

    }
  }
</script>